<template>
<v-card class='mt-3 pt-1 mx-auto' v-resize='onResize'>
  <v-sheet class='v-sheet--offset mx-auto pa-0' :color='color' elevation='10' max-width='calc(100% - 32px)' height='240'>
    <div :ref='ref' class='pt-3' style='width: 98%; height: 220px;' :style='setStyle' />
  </v-sheet>

  <v-card-text class='pt-0'>
    <div class='title font-weight-light mb-2'><b>{{ title }}</b></div>
    <div class='subheading font-weight-light grey--text'>{{ desc }}</div>
    <v-divider class='my-2' />
    <v-icon class='mr-2' small>mdi-clock</v-icon>
    <!-- <span class='caption grey--text font-weight-light'>last update {{ random(20) }} minutes ago</span> -->
  </v-card-text>
</v-card>
</template>


<script>
import color from '@/components/plugins/color'

export default {
  props: ['title', 'desc', 'color'],
  data: () => ({
    chart: null,
    option: null,
    labels: ['Sun','Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
    buildingLoadTimes: [],
    buildingLoadData: [],
    netPowerTimes: [],
    netPowerData: [],
    netPowerAxisInterval: 20,
    buildingLoadAxisInterval: 5
  }),
  computed: {
    ref() {
      return `echartsCard${ this.title }`
    },
    setStyle() {
      return {
        background: this.color
      }
    },
    // yesterdayBuildingLoad(){
    //   return this.$store.state.skyspark.yesterdayBuildingLoad;
    // },
    todayBuildingLoad(){
      return this.$store.state.skyspark.todayBuildingLoad;
    },
    // yesterdayNetPower(){
    //   return this.$store.state.skyspark.yesterdayNetPower;
    // },
    todayNetPower(){
      return this.$store.state.skyspark.todayNetPower;
    },
  },
  methods: {
    // valueAcu() {
    //   const arr = [...this.energyUse]
    //   this.energyUse.forEach((item,index) => (arr[index] = index > 0 ? arr[index-1]+item : ''))
    //   console.log(arr)
    //   return arr
    // },
    processData(){
      // console.log(this.yesterdayBuildingLoad)
      this.todayBuildingLoad.forEach((el,ind)=>{
        this.buildingLoadTimes[ind] = el.slice(0,-1)[0].toLocaleTimeString([],{month: 'numeric', day: 'numeric', hour12: false, hour: '2-digit'});
        this.buildingLoadData[ind] = el.slice(1)[0];
      })
      // let moreTimes = [];
      // let moreData = [];
      // this.todayBuildingLoad.forEach((el,ind)=>{
      //   moreTimes[ind] = el.slice(0,-1)[0].toLocaleTimeString([],{month: 'numeric', day: 'numeric', hour12: false, hour: '2-digit'});
      //   moreData[ind] = el.slice(1)[0];
      // })
      // this.buildingLoadTimes = this.buildingLoadTimes.concat(moreTimes);
      // this.buildingLoadData = this.buildingLoadData.concat(moreData);
      // console.log(this.buildingLoadTimes);
      // console.log(this.buildingLoadData);

      this.todayNetPower.forEach((el,ind)=>{
        this.netPowerTimes[ind] = el.slice(0,-1)[0].toLocaleTimeString([],{month: 'numeric', day: 'numeric', hour12: false, hour: '2-digit'});
        this.netPowerData[ind] = el.slice(1)[0];
      })
      // moreTimes = [];
      // moreData = [];
      // this.todayNetPower.forEach((el,ind)=>{
      //   moreTimes[ind] = el.slice(0,-1)[0].toLocaleTimeString([],{month: 'numeric', day: 'numeric', hour12: false, hour: '2-digit'});
      //   moreData[ind] = el.slice(1)[0];
      // })
      // this.netPowerTimes = this.netPowerTimes.concat(moreTimes);
      // this.netPowerData = this.netPowerData.concat(moreData);
      // console.log(this.netPowerTimes);
      // console.log(this.netPowerData);
    },
    drawChart(refresh) {
      this.chart.setOption(this.option, refresh)
      // console.log(this.chart.getOption())
      this.onResize()
    },
    onResize() {
      if(this.chart) _.debounce(this.chart.resize, 100)()
    },
    scaleAxes() {
      // console.log(Math.min(...this.netPowerData)/(Math.max(...this.netPowerData)-Math.min(...this.netPowerData))*(Math.max(...this.buildingLoadData)-Math.min(...this.buildingLoadData)));
      // return -1*Math.ceil(Math.abs(Math.min(...this.netPowerData)/this.netPowerAxisInterval))*this.buildingLoadAxisInterval;
      let buildingLoadRange = Math.max(...this.buildingLoadData) - Math.min(...this.buildingLoadData);
      let netPowerRange = Math.max(...this.netPowerData) - Math.min(...this.netPowerData);
      let rangeRatio = buildingLoadRange/netPowerRange;
      let maxRatio = Math.max(...this.buildingLoadData)/Math.max(...this.netPowerData);
      // console.log(rangeRatio)
      return [Math.floor(Math.floor(Math.min(...this.netPowerData)/this.netPowerAxisInterval)*this.netPowerAxisInterval*maxRatio),Math.ceil(Math.ceil(Math.max(...this.netPowerData)/this.netPowerAxisInterval)*this.netPowerAxisInterval*maxRatio)]
    },
    refreshChart() {
      this.processData();
      // console.log(this.scaleAxes())
      this.option = {
        color,
        tooltip: {
          trigger: 'axis'
        },
        textStyle: {
          color: 'white',
          fontSize: 8
        },
        grid: {
          // containLabel: true,
          top: 5,
          left: 10,
          right: 10,
          bottom: 20,
          // width: '100%',
          // height: '100%',
        },
        legend: {
          left: 'left',
          orient: 'horizontal',
          textStyle: {
            fontSize: 16,
          }
        },
        xAxis: [{
          type: 'category',
          axisLine: {
            show: true,
            onZeroAxisIndex: 1,
          },
          onZero: false,
          onZeroAxisIndex: 1,
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          data: this.buildingLoadTimes,
        }],
        yAxis: [{
          show: false,
          type: 'value',
          name: 'line',
          // splitLine: {
          //   show: true,
          //   interval: 100,
          // },
          min: this.scaleAxes()[0],
          max: this.scaleAxes()[1],
          // interval: this.buildingLoadAxisInterval,
          // max: 600,
        },
        {
          show: false,
          type: 'value',
          name: 'line',
          axisLine: {
            onZero: true,
            onZeroAxisIndex: 0,
          },
          // min: 0,
          //max: 3600,
          interval: this.netPowerAxisInterval,
        }],
        series: [{
          name: 'Building Load (kWh)',
          type: 'line',
          lineStyle: {
              width: 3,
              color: 'green',
              shadowColor: 'rgba(0,0,0,0.7)',
              shadowBlur: 10,
              shadowOffsetY: 10
          },
          itemStyle: {
            color: 'green',
          },
          smooth: false,
          data: this.buildingLoadData
        }, {
          name: 'Returned to Grid (kWh)',
          type: 'bar',
          yAxisIndex: 1,
          itemStyle: {
            color: 'rgba(255, 255, 255, 0.55)',
            BorderRadius: [3, 3, 0, 0]
          },
          data: this.netPowerData
        }]
      }
    }
    // random(x) {
    //   return _.random(5, x)
    // }
  },
  watch: {
    todayBuildingLoad: function(newData,oldData){
      this.refreshChart()
      this.drawChart();
    },
    todayNetPower: function(newData,oldData){
      this.refreshChart()
      this.drawChart();
    }
  },
  mounted() {
    // console.log(this.weeklyBuildingLoad)
    this.chart = echarts.init(this.$refs[this.ref])
    this.refreshChart();
    this.drawChart()
  },
  beforeDestroy() {
    echarts.dispose(this.chart)
  }
}
</script>

<style lang='stylus'>
.v-sheet--offset
  top: -24px
  position: relative
</style>
